var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('portal-target',{attrs:{"name":"appbar"}}),_c('PricingDialog'),_c('v-content',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }